import { AddQuestionComponent } from './../add-question/add-question.component';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { QuestionsService } from '../../services/questionsService';
import { UpdateQuestionComponent } from '../update/update-question.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'ngx-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss'],
})
export class QuestionsComponent extends BaseComponent implements OnInit {
  constructor(
    public service: QuestionsService,
    public route: Router,
    public paging: PagingService,
    private diag: NbDialogService,
    private toast: NbToastrService
  ) {
    super(route, service, paging, '');
  }

  ngOnInit() {
    this.loadEntities();
  }

  add() {
    this.diag.open(AddQuestionComponent).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }
  update(question) {
    this.diag.open(UpdateQuestionComponent, { context: { question: question } }).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }
    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }
}
